module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('PageHeader', {
    attrs: {
      "title": "Define Micro Notes"
    }
  }, [(_vm.lectureNote && _vm.microNotable()) ? _vm._c('a', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.convertToMicroNotes($event)
      }
    },
    slot: "top"
  }, [_vm._c('i', {
    staticClass: "fas fa-save"
  }), _vm._v("   Create micro notes\n    ")]) : _vm._c('a', {
    staticClass: "btn btn-default btn-lg disabled",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "href": "",
      "disabled": ""
    },
    slot: "top"
  }, [_vm._c('i', {
    staticClass: "fas fa-save"
  }), _vm._v("   Create micro notes\n    ")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn btn-danger btn-lg",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "to": {
        name: 'subject-shelf'
      }
    },
    slot: "top"
  }, [_vm._c('i', {
    staticClass: "fas fa-arrow-left"
  }), _vm._v("   Cancel\n    ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._c('Help', {
    attrs: {
      "showhelp": _vm.showHelp
    }
  }, [_vm._c('div', {
    slot: "content"
  }, [_vm._v("\n          Split your lecture notes into micro notes with the "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" button. Select keywords to be hidden/tested with the "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-key"
  })]), _vm._v(" button."), _vm._c('br'), _vm._v("\n          Click an image and select "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-object-group"
  })]), _vm._v(" to convert the image to a micro note. Image keywords can be set in the next stage."), _vm._c('br'), _vm._v("\n          Click "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-save"
  }), _vm._v(" Create micro notes")]), _vm._v(" to save and proceed to micro note image editing.\n        ")])])], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "text-right pull-right"
  }, [(_vm.lectureNote) ? _vm._c('KeywordSettings', {
    attrs: {
      "chapterId": _vm.lectureNote.chapter_id
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row height-100"
  }, [_vm._c('div', {
    staticClass: "col-md-12 height-100"
  }, [(_vm.lectureNote) ? _vm._c('div', {
    staticClass: "height-100-minus"
  }, [(_vm.showReplaceWarning) ? _vm._c('div', {
    staticClass: "bg-danger clearfix"
  }, [_vm._c('p', {
    staticClass: "pull-left"
  }, [_vm._c('b', [_vm._v("Warning:")]), _vm._v(" You've created " + _vm._s(_vm.lectureNote.micro_note_count) + " micro notes based on this lecture note. Those micro notes will be deleted. Are you sure you want to proceed?\n            ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "pull-right"
  }, [_vm._c('a', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.replaceMicroNotes($event)
      }
    }
  }, [_vm._v("\n                Replace\n              ")]), _vm._v(" "), _vm._c('a', {
    staticClass: "btn btn-default btn-sm btn-margin",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleReplaceWarning($event)
      }
    }
  }, [_vm._v("\n                Cancel\n              ")])])]) : _vm._e(), _vm._v(" "), _vm._c('FroalaEditor', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lectureNote.html),
      expression: "lectureNote.html"
    }],
    ref: "editor",
    attrs: {
      "chapterId": _vm.lectureNote.chapter_id,
      "config": _vm.froalaConfig,
      "image-created-function": _vm.imageCreated
    },
    domProps: {
      "value": (_vm.lectureNote.html)
    },
    on: {
      "change": _vm.saveLectureNote,
      "input": function($event) {
        _vm.lectureNote.html = $event
      }
    }
  }), _vm._v(" "), (_vm.lectureNote && _vm.microNotable()) ? _vm._c('a', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.convertToMicroNotes($event)
      }
    },
    slot: "top"
  }, [_vm._c('i', {
    staticClass: "fas fa-save"
  }), _vm._v("   Create micro notes\n          ")]) : _vm._c('a', {
    staticClass: "btn btn-default btn-lg disabled",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "href": "",
      "disabled": ""
    },
    slot: "top"
  }, [_vm._c('i', {
    staticClass: "fas fa-save"
  }), _vm._v("   Create micro notes\n          ")])], 1) : _vm._c('div', [_vm._c('LoadingIndicator')], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ffc54be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecture-note-editor/LectureNoteEditor.vue
// module id = 631
// module chunks = 1